import { ref, onMounted, onUnmounted, computed } from "vue";

type Breakpoints = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
const breakpointArray: Breakpoints[] = ["xs", "sm", "md", "lg", "xl", "xxl"];

const breakpoints: Record<Breakpoints, number> = {
  xs: 0,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1400,
  xxl: 1600,
};

const currentSize = ref(0);

export function useResponsiveController() {
  const checkBreakpoint = () => {
    currentSize.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener("resize", checkBreakpoint);
    checkBreakpoint();
  });

  onUnmounted(() => {
    window.removeEventListener("resize", checkBreakpoint);
  });
}

export const useScreen = () => {
  const currentBreakpoint = computed(() => {
    const keys = Object.keys(breakpoints) as Breakpoints[];
    for (const key of keys) {
      if (currentSize.value < breakpoints[key]) {
        return key;
      }
    }
    return keys[keys.length - 1];
  });
  const screen = computed(() => ({
    gt: {
      xs: currentSize.value > breakpoints.xs,
      sm: currentSize.value > breakpoints.sm,
      md: currentSize.value > breakpoints.md,
      lg: currentSize.value > breakpoints.lg,
      xl: currentSize.value > breakpoints.xl,
      xxl: currentSize.value > breakpoints.xxl,
    },
    lt: {
      sm: currentSize.value < breakpoints.sm,
      md: currentSize.value < breakpoints.md,
      lg: currentSize.value < breakpoints.lg,
      xl: currentSize.value < breakpoints.xl,
      xxl: currentSize.value < breakpoints.xxl,
    },
  }));

  const texts = (
    values: Partial<Record<Breakpoints, string | undefined>>
  ): string => {
    let text = "";
    for (const key of breakpointArray) {
      text = values[key] ?? text;
      if (currentBreakpoint.value === key) {
        return text;
      }
    }
    return text;
  };

  return { screen, texts };
};
